/** @jsxImportSource @emotion/react */

import { fabric } from 'fabric';

import { ALargeSmall } from 'lucide-react';
import { useSelector } from 'react-redux';
import customization from 'ud-ui/components/fabric-canvas/addons/customization';
import history from 'ud-ui/components/fabric-canvas/addons/history';
import SnapToGrid from 'ud-ui/components/fabric-canvas/addons/snap-to-grid';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from '../../../../store/editor/selectors';

export function AddText() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);

  const addText = (text: string) => {
    if (!fabricManager) return;
    history.saveState();
    const { left, top } = fabricManager.getLeftTopCurVP();

    const textBox = new fabric.Textbox(text, {
      fontSize: 20,
      fontFamily: 'Open Sans, sans-serif',
      left,
      top,
      strokeLineJoin: 'round',
      strokeWidth: 0,
      fontWeight: 'normal',
      fill: '#000000FF',
      ...customization.getAllProperties(),
    });

    textBox.on('editing:exited', () => {
      if (textBox.text !== undefined && textBox.text.replace(/\s+/g, ' ').trim() !== '') return;
      fabricManager.canvas.remove(textBox);
    });

    fabricManager.canvas.add(textBox);
    SnapToGrid.snapToGrid([textBox]);
  };

  const onClickAddText = () => {
    if (!fabricManager) return;
    addText('Новый текст');
  };

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Текст'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton variant="ghost" icon={<ALargeSmall size={20} strokeWidth={1.5} />} onClick={onClickAddText} tabIndex={0} />
      </span>
    </UDTippy>
  );
}
